import { useState } from 'react';
import CountLink from './CountLink';
import AtsAdmissionsDialog from './AtsAdmissionsDialog';
import { CASE_LABEL, prefetchAtsAdmissions } from './atsAdmissions';

// Makes the "Course enrollments" column on ATS clickable and owns the popup:
//   const drill = useAtsDrilldown(month);
//   { field: 'enrollmentsCount', headerName: 'Course enrollments', align: 'right', render: drill.cell('enrollmentsCount') }
//   ...
//   {drill.dialog}
const useAtsDrilldown = (month) => {
  const [open, setOpen] = useState(null);
  const requestFor = (row) => ({ userId: row.entityId, userName: row.entityName, caseType: row.caseType, month });

  const cell = (field) => (row) => (
    <CountLink
      count={row[field]}
      label={`${(CASE_LABEL[row.caseType] || '').toLowerCase()} course enrollments of ${row.entityName}`.trim()}
      onOpen={() => setOpen(requestFor(row))}
      onPrefetch={() => prefetchAtsAdmissions(requestFor(row))}
    />
  );

  const dialog = open ? <AtsAdmissionsDialog request={open} onClose={() => setOpen(null)} /> : null;
  return { cell, dialog };
};

export default useAtsDrilldown;
